export default "__VITE_ASSET__BqT119W9__"